import type { LeadRequest, LeadServiceResponse } from "@component/assets/AbstractLeadForm/types";
import { Config } from "@config";
import http from "@utils/http";
import { SessionStorage } from "@utils/session-storage";
import { getUrlParameter } from "@utils/url";

export const submitLead = async ({
	consultant,
	source,
	sourceBrowser,
	sourcePage,
	response,
	...other
}: LeadRequest<any, any>): Promise<LeadServiceResponse> => {
	const extendedLeadData = {
		...other,
		consultant: consultant || getUrlParameter("consultant"),
		source: source || getUrlParameter("source", Config.getLeadSource()),
		sourceBrowser:
			sourceBrowser ||
			["ga" in window && "GA", "google_tag_manager" in window && "GTM", navigator?.userAgent]
				.filter(Boolean)
				.join(" + "),
		sourcePage: sourcePage || window.location.href,
		response: {
			...response,
			lastViewedContent: SessionStorage.get("bm-last-viewed-article"),
		},
	};

	const res = await http.post<LeadServiceResponse>(Config.getWpRestApiUrl("/lead"), extendedLeadData);

	if (!res.leadId) {
		throw new Error("Lead ID is missing");
	}

	return res;
};
